import { enqueueSnackbar } from 'notistack';
import { handleErrors } from '../../../../utils/functions';
import { showAlert } from '../../../../redux/slices/appSlice';
import { useAppDispatch } from '../../../../hooks/reduxHooks';
import { useCallback, useMemo, useState } from 'react';
import { useDeleteUserMutation, useGetUsersQuery } from '../../../../services/adminApi';

function useUsers() {
    const dispatch = useAppDispatch();
    const [filterModelValue, setFilterModelValue] = useState<string>('');
    const [drawerAction, setDrawerAction] = useState<string>('');
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const [deleteUser, { isLoading: deletingUser }] = useDeleteUserMutation();

    const {
        data: users,
        isLoading: loadingUsers,
        isFetching: fetchingUsers
    } = useGetUsersQuery({}, { refetchOnMountOrArgChange: true });

    const btnSelectStyle = useMemo(
        () => `& .MuiDataGrid-actionsCell button[aria-label="menuItemBtn-${selectedItem?.id}"]`,
        [selectedItem]
    );

    const handleCloseMenu = () => {
        setSelectedItem(null);
        setAnchorEl(null);
    };

    const onInputChange = useCallback((e: any) => {
        setFilterModelValue(e?.target?.value || '');
    }, []);

    const handleCloseDrawer = useCallback(() => {
        setDrawerAction('');
        if (selectedItem) setSelectedItem(null);
        // eslint-disable-next-line
    }, [selectedItem]);

    const handleOpenDrawer = useCallback((value: string = '') => {
        setDrawerAction(value);
    }, []);

    const handleMenuAction = useCallback((params: any, event: any) => {
        setSelectedItem(params);
        setAnchorEl(event.currentTarget);
    }, []);

    const handleDeleteUser = useCallback((item: any) => {
        const submit = async () => {
            const response: any = await deleteUser(item?.id);
            if (!response?.error) {
                setSelectedItem(null);
                enqueueSnackbar(response?.data?.message || 'Usuario eliminado correctamente.', {
                    variant: 'success'
                });
            } else {
                handleErrors(response?.error);
            }
        };

        dispatch(
            showAlert({
                title: '¿Eliminar usuario?',
                message: `Si eliminas '${item?.row?.cuil}' ya no estará disponible`,
                keepMounted: true,
                cancelText: 'Cancelar',
                confirmText: 'Sí, eliminar',
                confirmAction: submit
            })
        );
        // eslint-disable-next-line
    }, []);

    const handleSubmitAction = (action: string) => {
        setAnchorEl(null);
        switch (action) {
            case 'view':
                return handleOpenDrawer('view');
            case 'edit':
                return handleOpenDrawer('edit');
            case 'delete':
                return handleDeleteUser(selectedItem);
            default:
                return;
        }
    };

    return {
        users,
        loadingUsers,
        fetchingUsers,
        anchorEl,
        selectedItem,
        drawerAction,
        btnSelectStyle,
        filterModelValue,
        deletingUser,
        handleDeleteUser,
        handleCloseDrawer,
        handleSubmitAction,
        handleCloseMenu,
        onInputChange,
        handleOpenDrawer,
        handleMenuAction
    };
}

export default useUsers;
